import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'

// import reservation from './reservation'
const localStorage = window.localStorage

const storageSet = (key, value) => {
  if (localStorage) localStorage.setItem(key, value)
  else cookie.set(key, value)
}
const storageRemove = key => {
  if (localStorage) localStorage.removeItem(key)
  else cookie.remove(key)
}
const storageGet = key => {
  if (localStorage) return localStorage.getItem(key)
  else return cookie.get(key)
}

Vue.use(Vuex)

const JWT_COOKIE_NAME = 'fufu shop-app jwt'
const SHOP_ID_COOKIE_NAME = 'fufu shop-app shopid'
const MODE_COOKIE_NAME = 'fufu shop-app mode'

function createState() {
  return {
    token: null,
    user: null,
    shop: null,
    swRegistered: false,
    swActivate: false,
    swUpdated: false,
    mode: 1,
  }
}

export default new Vuex.Store({
  state: createState(),
  getters: {
    loggedIn: ({ token }) => Boolean(token),
    token: ({ token }) => token,
    shopId: ({ user }) => user && user.shopBase,
    user: ({ user }) => user,
    shop: ({ shop, user }) => shop || (user && user.shop),
    swRegistered: ({ swRegistered }) => swRegistered,
    swActivate: ({ swActivate }) => swActivate,
    swUpdated: ({ swUpdated }) => swUpdated,
    mode: ({ mode }) => Number(mode) || 1,
  },
  mutations: {
    LOGIN(state, { access, refresh, user }) {
      state.token = access
      state.user = user
      storageSet(JWT_COOKIE_NAME, refresh)
    },
    CLEAR(state) {
      Object.assign(state, createState())
      storageRemove(JWT_COOKIE_NAME)
    },
    SET_SHOP(state, shop) {
      state.shop = shop
      if (shop) storageSet(SHOP_ID_COOKIE_NAME, shop.id)
      else storageRemove(SHOP_ID_COOKIE_NAME)
    },
    SW_REGISTERED(state) {
      // service workerが登録された
      state.swRegistered = true
    },
    SW_ACTIVATE(state) {
      // service workerがactivate、かつnavigator.serviceWorker.controllerが非null
      state.swActivate = true
    },
    SW_UPDATED(state) {
      // service workerが更新可能
      state.swUpdated = true
    },
    SET_MODE(state, mode) {
      state.mode = Number(mode) || 1
      storageSet(MODE_COOKIE_NAME, state.mode)
    },
  },
  actions: {
    async login({ commit }, data) {
      let res = await this.$api.auth.obtainToken(data)
      commit('LOGIN', res)
    },
    async refresh({ commit }) {
      const refresh = storageGet(JWT_COOKIE_NAME)
      if (!refresh) return
      try {
        let data = await this.$api.auth.refreshToken({ refresh })
        commit('LOGIN', data)
      } catch (err) {
        if (err.status === 401) commit('CLEAR')
      }
    },
    clear({ commit }) {
      commit('CLEAR')
    },
    setShop({ commit }, shop) {
      commit('SET_SHOP', shop)
    },
    setMode({ commit }, mode) {
      commit('SET_MODE', mode)
    },
    async loadStore({ commit }) {
      const mode = storageGet(MODE_COOKIE_NAME)
      commit('SET_MODE', mode)
      const shopId = storageGet(SHOP_ID_COOKIE_NAME)
      if (shopId) commit('SET_SHOP', await this.$api.shops(shopId).get())
    },
    swRegistered({ commit }) {
      commit('SW_REGISTERED')
    },
    swActivate({ commit }) {
      commit('SW_ACTIVATE')
    },
    swUpdated({ commit }) {
      commit('SW_UPDATED')
    },
  },
  modules: {
    // reservation,
  },
})
